import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {getRoles} from '~model/ngrx/auth-ngrx';
import {checkRoles, getDetailsScopes, Paths} from '~core/security/auth.roles';
import {LSItem} from '~utils/storage-utils';
import {JwtHelperService} from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root',
})
export class LogadoActiveGuard {
  constructor(
    private router: Router,
    private jwt: JwtHelperService
  ) {
  }

  canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Activate> | Promise<Activate> | Activate {
    const token = localStorage.getItem(LSItem.token);
    const tokenRules = localStorage.getItem(LSItem.tokenRules);
    const logado = !!token;
    const inLoginPage = state.url.startsWith('/' + Paths.LOGIN);

    const {scopes} = getDetailsScopes(this.jwt, tokenRules || '');
    const roles = getRoles(token || '');
    if (logado !== inLoginPage) {
      return checkRoles(state.url, roles, scopes, this.router);
    }
    let extras;
    let url = '/' + (scopes[roles[0]]?.defaultPage || Paths.LOGIN);
    if (!inLoginPage) {
      url = '/' + Paths.LOGIN;
      extras = {queryParams: {return: state.url}};
    }
    this.router.navigate([url], extras).then();
    return false;
  }
}

declare type Activate = boolean | UrlTree;
